/**
 * Displays the details of a tasteprofile
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import upperFirst from 'lodash/upperFirst'

import { WineListInline } from 'environments/TasteProfileOnboarding/components'
import Tooltip from 'components/Tooltip'
import styles from './resultDetail.css'
import tasteDescriptions from 'constants/tasteDescriptions'
import tasteNames from 'constants/tasteNames'
import { RED, WHITE } from 'constants/wines'
import { createTasteProfileEvent } from 'utils/tagManager'

export class ResultDetail extends Component {
  renderTasteElement (taste, index) {
    const { tasteElements, className, browser } = this.props
    const name = tasteNames[taste]
    const description = tasteDescriptions[taste]
    const level = tasteElements.get(taste)
    const percentage = (level * (100 / 3)).toFixed()
    let tooltipWidth = '260px'
    if (browser.is.screenXS && index > 0) {
      tooltipWidth = '220px'
    }
    const tooltipStyle = {
      position: 'topLeft',
      width: tooltipWidth
    }

    return (
      <li key={`${taste}`} className={styles.tasteElement}>
        <div className={styles.tasteElementLabel}>
          {upperFirst(name)}&nbsp;
          <Tooltip
            trigger={<span className={styles.infoIcon}>&#9432;</span>}
            style={tooltipStyle}
            trackingObject={createTasteProfileEvent('hover', `Smaakelement - ${name}`, true)}
          >
            {description}
          </Tooltip>
          <span className="hidden">{`: ${percentage}%`}</span>
        </div>
        <div className={styles.barWrapper}>
          <div className={classNames(className, styles.taste)} data-level={level} />
        </div>
      </li>
    )
  }

  render () {
    const {
      color,
      name,
      description,
      tasteElements,
      tasteType
    } = this.props

    // flatten taste profile object to pass as prop to WineListInline
    const tasteElementsObj = {}
    tasteElements.forEach((value, key) => {
      tasteElementsObj[key] = value
    })
    const tasteProfile = {
      color,
      tasteProfile: name,
      tasteType,
      ...tasteElementsObj
    }

    return (
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <ul className={styles.tasteElements}>
            {[...tasteElements.keys()]
              .filter((tasteElement) => !(tasteElement === 'tannin' && color === WHITE))
              .map((tasteElement, index) => this.renderTasteElement(tasteElement, index))}
          </ul>

          <p className={styles.tasteType}>
            <span className={styles.tasteTypeLabel}>Smaaktype:</span>
            <span className={styles.tasteTypeName}>{tasteType}</span>
          </p>

          <p className={styles.description}>
            {description}
          </p>
        </div>

        <WineListInline tasteProfile={tasteProfile} />
      </div>
    )
  }
}

ResultDetail.propTypes = {
  color: PropTypes.oneOf([RED, WHITE]).isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  tasteElements: PropTypes.objectOf(PropTypes.number).isRequired,
  tasteType: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  browser: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  browser: state.browser
})

export default connect(mapStateToProps)(ResultDetail)
